var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoachingSmallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 11,
    viewBox: "0 0 20 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8111 6.87622C12.7594 6.40882 11.4651 6.06726 10 6.06726C8.53488 6.06726 7.24055 6.41781 6.1889 6.87622C5.21815 7.30766 4.60693 8.27842 4.60693 9.33905V9.88735C4.60693 10.3817 5.01141 10.7862 5.50578 10.7862H14.4942C14.9886 10.7862 15.3931 10.3817 15.3931 9.88735V9.33905C15.3931 8.27842 14.7818 7.30766 13.8111 6.87622Z",
    fill: "#9D9DE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.09415 7.71213C0.429004 7.99976 -0.00244141 8.64692 -0.00244141 9.37499V9.88733C-0.00244141 10.3817 0.402038 10.7862 0.896402 10.7862H4.04236V9.33903C4.04236 8.59299 4.24909 7.89189 4.60863 7.28068C4.27606 7.22675 3.94348 7.1908 3.59293 7.1908C2.70308 7.1908 1.85817 7.37955 1.09415 7.71213Z",
    fill: "#9D9DE3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9034 7.71213C18.1394 7.37955 17.2945 7.1908 16.4046 7.1908C16.0541 7.1908 15.7215 7.22675 15.3889 7.28068C15.7485 7.89189 15.9552 8.59299 15.9552 9.33903V10.7862H19.1011C19.5955 10.7862 20 10.3817 20 9.88733V9.37499C20 8.64692 19.5685 7.99976 18.9034 7.71213Z",
    fill: "#9D9DE3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 5.39306C11.4923 5.39306 12.6968 4.18861 12.6968 2.69653C12.6968 1.20445 11.4923 0 10.0002 0C8.50816 0 7.30371 1.20445 7.30371 2.69653C7.30371 4.18861 8.50816 5.39306 10.0002 5.39306Z",
    fill: "#9D9DE3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59294 2.24434L1.34302 4.49426L3.59294 6.74419L5.84287 4.49426L3.59294 2.24434Z",
    fill: "#9D9DE3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4048 2.69653L14.1577 6.29191H18.6519L16.4048 2.69653Z",
    fill: "#9D9DE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoachingSmallIcon);
export default __webpack_public_path__ + "static/media/coaching-small-icon.46b82122.svg";
export { ForwardRef as ReactComponent };